import { render, staticRenderFns } from "./QuestionTypeTextVideo.vue?vue&type=template&id=2d113984"
import script from "./QuestionTypeTextVideo.vue?vue&type=script&lang=js"
export * from "./QuestionTypeTextVideo.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeTextVideo.vue?vue&type=style&index=0&id=2d113984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports